module.exports = __webpack_public_path__ + "img/board_governance.3d7e8c4b.jpg";